import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';

// Models
import { DgoAuth } from 'src/app/modules/public/models/dgo';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { UserService } from 'src/app/modules/account/user.service';

// Components
import { UiDialogComponent } from 'src/app/platform/components/ui-dialog/ui-dialog.component';
import { DeviceService } from 'src/app/platform/services/device.service';
import { Credentials } from 'capacitor-native-biometric';


@Component({
  selector: 'app-dgo',
  templateUrl: './dgo.component.html',
  styleUrls: ['./dgo.component.scss']
})
export class DgoComponent implements OnInit {
  public user: string = '';
  public password: string = '';
  public response: any;
  public request: boolean;
  public passwordVisibility = false;
  public dgoAuth: DgoAuth;

  constructor(
    private router: Router,
    private uiDialog: MatDialog,
    private userService: UserService,
    private deviceService: DeviceService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.dgoAuth = new DgoAuth(params);
    });
  }

  onDevInfo(): void{
    this.uiDialog.open(UiDialogComponent, {
      width: '350px',
      data: {
        title: 'Desarrollado por Clousis',
        message: 'Sistema de autogestión IpTel 1.0.0<br>Clousis - <a href="https://www.clousis.com?ref=iptel-plataforma" target="_blank">www.clousis.com</a>',
        buttonCancelText: 'Cerrar',
        buttonConfirmText: ''
      }
    });
  }

  setLocation(path: string): void{
    if (!this.request) {
      this.router.navigate([path]);
    }
  }

  onLogin(): void{
    if (this.user && this.password) {
      this.response = {};
      this.request = true;

      this.userService.dgoLogin(this.user, this.password, this.dgoAuth.data).then((response) => {
        if (response.status === true){
          this.deviceService.biometricSetCredentials(this.user, this.password).then(() => {
            window.location.href = response.result;
          });
        } else {
          this.response = { message: response.message != '' ? response.message : 'No es posible ingresar a la cuenta en este momento. Por favor intentá nuevamente más tarde.' };
        }
      }).catch((error) => {
        this.response = { message: error.message != '' ? error.message : 'No es posible ingresar a la cuenta en este momento. Por favor intentá nuevamente más tarde.' };
      }).finally(() => {
        this.request = false;
      });
    } else {
      this.response = {message: 'Es necesario completar todos los datos.'};
    }
  }

  biometricAvailable: boolean = this.deviceService.biometricAvailable;
  
  biometricAuth(){
    this.deviceService.biometricGetCredentials().then((credentials: Credentials | false | undefined) => {
      console.log('biometricGetCredentials then', credentials);

      if (credentials !== undefined && credentials !== false) {
        this.user = credentials.username;
        this.password = credentials.password;

        this.onLogin();
      }
    }).catch(error => {
      console.log('biometricGetCredentials catch', error);
    });
  }
}
